import CloseIcon from '../Close';
import React from 'react';
import { COLORS } from '../../../../config/designSystem/Colors';
import { DropShadowLightBlueStyle } from '../../../../config/designSystem/Shadow';
import { SPACING } from '../../../../config/designSystem/Spacing';
import { TouchableOpacity } from 'react-native';

interface CloseIconProps {
  size: number;
  onPress: () => void;
  color?: string;
}

export const EvolunoClose: React.FC<CloseIconProps> = ({
  size,
  onPress,
  color = COLORS.content.accent,
}) => {
  const SIZE = Math.max(SPACING['sp-40'], size);
  const PADDING = SPACING['sp-12'];
  const SIZE_ICON = SIZE -  2* PADDING;

  return (

    <TouchableOpacity onPress={onPress} style={[{
      padding: PADDING,
      backgroundColor: COLORS.surface.contrast,
      width: SIZE, height: SIZE, borderRadius: SIZE/2 },
    DropShadowLightBlueStyle]}>
      <CloseIcon width={SIZE_ICON} height={SIZE_ICON} color={color} />
    </TouchableOpacity>

  );
};

